require('./payrollLoanKOxDTI.scss');

const PropTypes = require('prop-types');

//@vendor
const React = require('react');
const { withRouter } = require("react-router-dom");

//@core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@components
const ContractPayrollLoanBiggerImport = require('../../contractPayrollLoan/contractPayrollLoanBiggerImport/contractPayrollLoanBiggerImport');
const PayrollLoanCalculationCard = require('../../contractPayrollLoan/payrollLoanCalculationCard/payrollLoanCalculationCard');
const PreleaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { findPurposeById } = require('../../contractPayrollLoan/payrollLoanPurposes');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

//@utilities
const { getFormattedString } = require('utilities/currencyHelper');

class PayrollLoanKOxDTI extends React.Component {
    constructor(props) {
        super(props);

        this.handleLeaveButton = this.handleLeaveButton.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.isReady = this.isReady.bind(this);
        this.dropRecord = this.dropRecord.bind(this);
    }

    buildBiggerImport() {
        const { immPayrollLoan, getInstallment, setLoanAmount,
            setLoanTerm, getMinTerm } = this.props;

        const initialized = immPayrollLoan.get('initialized');

        return initialized ? (
            <ContractPayrollLoanBiggerImport
                immContractPayrollLoan={immPayrollLoan}
                getInstallment={getInstallment}
                setLoanAmount={setLoanAmount}
                setLoanTerm={setLoanTerm}
                getMinTerm={getMinTerm}
            />
        ) : null;
    }

    buildSubtitle() {
        const { immPayrollLoan } = this.props;
        const lower = immPayrollLoan.get('lower');
        const nameValueAmount = lower
            ? "payrollLoanKOxDTI-subtitleLowerAmount1"
            : "payrollLoanKOxDTI-subtitleBiggerAmount1";
        const amount = lower ? immPayrollLoan.get('selectedAmount') : immPayrollLoan.get('maxAmount');
        const currencyValue = getFormattedString(
            { amount, currency: immPayrollLoan.get('currency') });
        const subtitleAmount2 = formatText('payrollLoanKOxDTI-subtitleAmount2');
        const termMin = immPayrollLoan.get('minTerm');

        return (
            <div className="payroll-loan-ko-dti__subtitle">
                <div>
                    <i className="icon payroll-loan-ko-dti__icon rebrand-loans" />
                </div>
                <div>
                    <FormattedText value={nameValueAmount} />
                    {currencyValue + subtitleAmount2 + termMin}
                    <FormattedText value="payrollLoanKOxDTI-subtitleAmount3" />
                </div>
            </div>
        );
    }

    buildTitle() {
        const { immPayrollLoan, isDragoFeature } = this.props;
        let titleText = formatText('payrollLoanKOxDTI-titleAmount');
        const purpose = isDragoFeature ? immPayrollLoan.get('selectedPurposeDrago') : findPurposeById(immPayrollLoan.get('selectedPurpose'));

        if (!!purpose) {
            const translationKey = purpose.payrollLoanContractsTransKey || '';

            if (!!translationKey) {
                titleText = titleText + formatText(translationKey);
            }
        }

        return (
            <div className="payroll-loan-ko-dti__title">
                {titleText}
            </div>
        );
    }

    dropRecord(callback) {
        const { immPayrollLoan } = this.props;
        this.props.cancelLoanRecord(immPayrollLoan.get('recordId'), callback);
    }

    handleLeaveButton() {
        this.props.history.push('/myprofile/loans-mortgages');
    }

    handleNextClick() {
        this.props.hideNewOfferView();
    }

    isReady() {
        return false;
    }

    render() {
        const { immPayrollLoan, taeTooltip, nodataKOxDTI, isCollective } = this.props;

        const preleaveModalMessage = formatText('payrollLoanRequest-modalLeaveText');
        const preleaveModalTitle = formatText('payrollLoanRequest-modalLeaveTitle');

        const preleaveModalLeftButtonConfig = {
            text: formatText('payrollLoanRequest-modalLeaveButton'),
            redirect: true,
            callback: this.dropRecord
        };

        const preleaveModalRightButtonConfig = {
            text: formatText('payrollLoanRequest-continueLater'),
            redirect: true
        };

        let taeTooltipElement;

        if (!nodataKOxDTI) {
            taeTooltipElement = taeTooltip;
        }

        const immCollective = immPayrollLoan.getIn(['collectiveInformation', '0']);
        const tin = isCollective ? immCollective.get('tin') : immPayrollLoan.get('tin');
        const tae = isCollective ? immCollective.get('tae') : immPayrollLoan.get('tae');
        const arrangementFee = immPayrollLoan.get('arrangementFee');
        const currency = immPayrollLoan.get('currency');
        const installment = immPayrollLoan.get('installment');
        const arrangementPercentage = immPayrollLoan.get('arrangementPercentage');
        const isFetching = immPayrollLoan.get('isFetchingMinTerm') || immPayrollLoan.get('isFetchingInstallment');
        const biggerImport = this.buildBiggerImport();
        const title = this.buildTitle();
        const subtitle = this.buildSubtitle();
        const isCallingApproveService = immPayrollLoan.get('callingApproveService');
        const content = isCallingApproveService ? <LoadingSection />
            : (
                <div>
                    <div className="payroll-loan-ko-dti__content">
                        {biggerImport}
                        <PayrollLoanCalculationCard
                            taeTooltip={taeTooltipElement}
                            tin={tin}
                            tae={tae}
                            arrangementFee={arrangementFee}
                            currency={currency}
                            installment={installment}
                            arrangementPercentage={arrangementPercentage}
                            isFetching={isFetching}
                            nodata={nodataKOxDTI}
                        />
                    </div>
                    <div className="payroll-loan-ko-dti__buttons">
                        <div className="payroll-loan-ko-dti__leave-button">
                            <OKButton
                                onClick={this.handleLeaveButton}
                                modifier="link-ghost"
                            >
                                <FormattedText value="payrollLoanRequest-leaveButton" />
                            </OKButton>
                        </div>
                        <OKButton
                            modifier="secondary"
                            onClick={this.handleNextClick}
                            rightIcon="icon-siguiente"
                        >
                            <FormattedText value="buttonsActions-next" format="firstUppercase" />
                        </OKButton>
                    </div>
                </div>);

        return (
            <OKSectionBox className="payroll-loan-ko-dti">
                <div className="payroll-loan-ko-dti__card">
                    <div className="payroll-loan-ko-dti__container">
                        {title}
                        <div className="payroll-loan-ko-dti__body">
                            {subtitle}
                        </div>
                    </div>
                </div>
                {content}
                <PreleaveModalComponent
                    acceptText={formatText('payrollLoanRequest-modalLeaveButton')}
                    cancelText={formatText('payrollLoanRequest-continueLater')}
                    confirmationMessage={preleaveModalMessage}
                    confirmationTitle={preleaveModalTitle}
                    leftButtonConfig={preleaveModalLeftButtonConfig}
                    rightButtonConfig={preleaveModalRightButtonConfig}
                    isReady={this.isReady}
                />
            </OKSectionBox>
        );
    }
}

PayrollLoanKOxDTI.propTypes = {
    immPayrollLoan: PropTypes.object.isRequired,
    taeTooltip: PropTypes.object.isRequired,
    cancelLoanRecord: PropTypes.func.isRequired,
    hideNewOfferView: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    getMinTerm: PropTypes.func.isRequired,
    isNewOffer: PropTypes.bool.isRequired,
    isCollective: PropTypes.bool,
    isDragoFeature: PropTypes.bool.isRequired,
    nodataKOxDTI: PropTypes.bool,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(PayrollLoanKOxDTI);
